import { createFeature, createReducer, on } from '@ngrx/store';

import { SharedCheckLocationActions } from './shared-check-location.actions';
import { SharedCheckLocationI } from 'src/app/api/shared-check-location/shared-check-location.result.int';

export interface State {
  data: SharedCheckLocationI;
  errorMessage: string;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  errorMessage: null,
  loaded: null,
  loading: null,
};

export default createFeature({
  name: 'sharedCheckLocation',
  reducer: createReducer(
    initialState,
    on(SharedCheckLocationActions.error, (state: State, { error }): State => ({
      ...state,
       loading: false,
        errorMessage: error
    })),
    on(SharedCheckLocationActions.load, (state: State, { }): State => ({
      ...state,
      loaded: false,
        loading: true,
        data: null,
    })),
    on(SharedCheckLocationActions.received, (state: State, { result }): State => ({
      ...state,
       loaded: true,
        loading: false,
        data: result,
    })),
    on(SharedCheckLocationActions.reset, (state: State): State => ({
      ...initialState
    })),
  )
}
);